import { styled } from '@mui/material/styles';
import { baseStyles } from '../../common/baseStyles';
export const StyledSnackbarContent = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    paddingTop: '8px',
    paddingBottom: '8px',
    flex: '1 0 0',
    boxSizing: 'border-box',
    minWidth: 0,
    ...baseStyles
  };
});